// Public page view beacon: one POST /api/v1/public/views per page load.
//
// The backend recorded views only on a GET /p/{slug} route nothing called once
// public pages became React routes, so landing-page views stopped on
// 2026-03-29. The public page now reports its own view, once it has rendered
// for a person (after any language redirect, never in the editor preview).
// The server drops bots, de-duplicates reloads within 30 minutes and works out
// unique visitors. /api/v1/public/ is proxied on the pages host too.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

// UTM tags on the page URL travel with the view and the form submission so
// both can be split by campaign. The server keeps only these keys.
export function utmFromLocation(search = window.location.search) {
  const params = new URLSearchParams(search);
  const source = {};
  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) source[key] = value;
  });
  return source;
}

const CLIENT_ID_KEY = 'lh_vid';

// A random first-party id, so a visitor on a changing mobile IP is still one
// visitor. Not personal data; absent when storage is blocked (the server then
// falls back to IP + browser).
export function getClientId() {
  try {
    let id = window.localStorage.getItem(CLIENT_ID_KEY);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
      window.localStorage.setItem(CLIENT_ID_KEY, id);
    }
    return id;
  } catch {
    return undefined;
  }
}

export function sendViewBeacon({ kind, slug, locale }) {
  if (!slug) return false;
  const body = JSON.stringify({
    kind,
    slug,
    locale: locale || undefined,
    utm: utmFromLocation(),
    referrer: document.referrer || undefined,
    path: window.location.pathname,
    vid: getClientId(),
  });
  const url = `${BACKEND_URL}/api/v1/public/views`;
  try {
    // text/plain keeps it a "simple" request: no CORS preflight.
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
      if (navigator.sendBeacon(url, blob)) return true;
    }
    fetch(url, {
      method: 'POST',
      body,
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {});
    return true;
  } catch {
    return false; // analytics must never break the page
  }
}
